<template>
  <div class="topicos-container">
    <div class="topico-item" v-for="(topico, index) in topicos" :key="index">
      <div class="topico-header">
        <h5>Tópico {{ index + 1 }} <span v-if="!!topico.titulo">- {{ topico.titulo }}</span></h5>
        <div class="topico-actions">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            @click="moverParaCima(index)"
            :disabled="index === 0"
            title="Mover para cima">
            <fa-icon icon="arrow-up" />
          </button>
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            @click="moverParaBaixo(index)"
            :disabled="index === topicos.length - 1"
            title="Mover para baixo">
            <fa-icon icon="arrow-down" />
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger"
            @click="removerTopico(index)"
            title="Remover tópico">
            <fa-icon icon="trash-alt" />
          </button>
        </div>
      </div>

      <div class="form-group">
        <label>Título</label>
        <input
          type="text"
          class="form-control"
          v-model="topico.titulo"
          @input="atualizarValor"
          placeholder="Digite o título do tópico">
      </div>

      <div class="form-group">
        <label>Pergunta para IA</label>
        <textarea
          class="form-control"
          v-model="topico.pergunta"
          @input="atualizarValor"
          rows="4"
          placeholder="Digite a pergunta que será enviada para a IA">
        </textarea>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary btn-block mt-3"
      @click="adicionarTopico">
      <i class="fa fa-plus"></i> Adicionar Tópico
    </button>
  </div>
</template>

<script>
import ncformCommon from '@ncform/ncform-common';

export default {
  name: "Topicos",
  mixins: [
    ncformCommon.mixins.vue.controlMixin
  ],
  data() {
    return {
      topicos: []
    }
  },
  watch: {
    modelVal: {
      handler(newVal) {
        if (newVal && typeof newVal === 'string') {
          try {
            this.topicos = JSON.parse(newVal);
          } catch (e) {
            this.topicos = [];
          }
        } else if (Array.isArray(newVal)) {
          this.topicos = newVal;
        } else {
          this.topicos = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    adicionarTopico() {
      this.topicos.push({
        titulo: '',
        pergunta: ''
      });
      this.atualizarValor();
    },
    removerTopico(index) {
      this.topicos.splice(index, 1);
      this.atualizarValor();
    },
    moverParaCima(index) {
      if (index > 0) {
        const temp = this.topicos[index];
        this.$set(this.topicos, index, this.topicos[index - 1]);
        this.$set(this.topicos, index - 1, temp);
        this.atualizarValor();
      }
    },
    moverParaBaixo(index) {
      if (index < this.topicos.length - 1) {
        const temp = this.topicos[index];
        this.$set(this.topicos, index, this.topicos[index + 1]);
        this.$set(this.topicos, index + 1, temp);
        this.atualizarValor();
      }
    },
    atualizarValor() {
      this.$emit('input', JSON.stringify(this.topicos, null, 2));
    }
  },
  mounted() {
    // Se não houver tópicos, adiciona um por padrão
    if (!this.topicos || this.topicos.length === 0) {
      this.adicionarTopico();
    }
  }
}
</script>

<style scoped>
.topicos-container {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.topico-item {
  background: white;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.topico-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.topico-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
}

.topico-actions {
  display: flex;
  gap: 8px;
}

.topico-actions .btn {
  min-width: 32px;
}

.topico-actions .btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

.form-group {
  margin-bottom: 15px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}

.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

textarea.form-control {
  resize: vertical;
  min-height: 80px;
}

.btn {
  cursor: pointer;
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.btn-block {
  width: 100%;
}

.mt-3 {
  margin-top: 1rem;
}
</style>
